<template>
  <CustomPage
    title="退货详情"
    :subtitle="subtitle"
    :noBorder="true"
    style="background: #f7f7f7"
  >
    <div slot="content">
      <div class="after-sale-container">
        <Header :data="data" />
        <div class="body">
          <MainPanel :data="data" />
          <AmountPanel :data="data" />
        </div>

        <div
          class="footer"
          v-if="
            data &&
            ['INITIAL', 'SUPPLIER_APPROVED'].indexOf(data.state) === -1 &&
            data.refundOnly === false
          "
        >
          <div class="btn van-hairline--surround" @click="readLocus(data)">
            查看物流
          </div>
        </div>
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import Bus from "@/utils/bus";
import CustomView from "@/components/custom-view.vue";
import CustomPage from "@/components/custom-page.vue";
import Header from "./components/Header";
import MainPanel from "./components/MainPanel";
import AmountPanel from "./components/AmountPanel";
import { getAfterSaleDetail, getAutoConfirmTime } from "@/api/order/afterSale";
export default {
  components: { CustomView, CustomPage, Header, MainPanel, AmountPanel },
  data() {
    return {
      id: this.$route.query.id,
      interval: null,
      subtitle: null,
      data: {},
    };
  },
  created() {
    this.getData();
    Bus.$on("refreshData", this.getData);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    formatDateDay(second) {
      const days = Math.floor(second / 86400);
      const hours = Math.floor((second % 86400) / 3600);
      const minutes = Math.floor(((second % 86400) % 3600) / 60);
      const seconds = Math.floor(((second % 86400) % 3600) % 60);
      let str = "";
      if (days > 0) {
        str += `${days}天`;
      }
      if (hours > 0) {
        str += `${hours < 10 ? "0" + hours : hours}小时`;
      }
      if (hours > 0 || minutes > 0) {
        str += `${minutes < 10 ? "0" + minutes : minutes}分`;
      }
      if (hours > 0 || minutes > 0 || seconds > 0) {
        str += `${seconds < 10 ? "0" + seconds : seconds}秒商家不处理自动退款`;
      }
      return str;
    },
    getAutoConfirmTime(state) {
      this.interval && clearInterval(this.interval);
      const params = {
        state,
        salesReturnId: this.data.id,
      };
      getAutoConfirmTime(params).then((res) => {
        let second = res.data;
        if (second) {
          let ss = Number(second);
          this.interval = setInterval(() => {
            this.subtitle = this.formatDateDay(ss);
            ss--;
            if (ss < 0) {
              clearInterval(this.interval);
            }
          }, 1000);
        }
      });
    },
    getData() {
      this.$store.dispatch("app/showLoading");
      getAfterSaleDetail({ id: this.id })
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          this.data = this.converData(res.data);
          this.getAutoConfirmTime(this.data.state);
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    converData(data) {
      data.orderItemTotal = data.orderItems.reduce(
        (prev, cur) => Number(prev) + Number(cur.qty),
        0
      );

      // // 给goodsItem增加图片
      // data.orderItem.forEach((item) => {
      //   const i = data.goodsInfo.find(
      //     (_item) => _item.goodsInfoId === item.skuId
      //   )
      //   item.goodsInfoImg = i ? i.goodsInfoImg : null
      // })
      return data;
    },

    readLocus(data) {
      let type = data.state === "REFUSED_REFUND" ? "SUPPLIER" : "CUSTOMER";
      const i = data.delivery.find((item) => item.type === type);
      this.$router.push({
        name: "OrderAfterSaleLocus",
        query: { ...i },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.after-sale-container {
  .body {
    padding: 0 24px;
    margin-top: -98px;
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
  padding: 0 24px;
  .btn {
    font-size: 28px;
    color: #666666;
    line-height: 28px;
    padding: 15px 20px;
    margin: 22px 0 20px;
    & + .btn {
      margin-left: 20px;
    }
    &::after {
      border-radius: 56px;
      border-color: #979797;
    }
  }
}
</style>
